import {
  CaretDownFilled,
  CaretUpFilled,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../routes";
import {
  SearchCurrentStakeholderContext,
  initialPageValues,
  initialSearchValues,
} from "../searchContext";
import { PAGES, PERMISSION_DATA } from "../../../../lib/const";
import useCountry from "../../../../lib/hooks/useCountry";
import useContactReason from "../../../../lib/hooks/useContactReason";
import moment from "moment";
import usePermission from "../../../../lib/hooks/usePermisson";
import { ThaiRangePicker } from "../../../../components/common/thaiDatePicker";

const dateFormat = "DD/MM/YYYY";
const { Title } = Typography;
const { Option } = Select;

const years = moment().format("YYYY");

const Search = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [roleUser] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.STAKEHOLDER
  );

  const [searchCollapse, setSearchCollapse] = useState(false);

  const [countries] = useCountry();
  const [contactReason] = useContactReason();

  const { setSearchValues, setPageValues, setSearch } = useContext(
    SearchCurrentStakeholderContext
  );

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [yearOfBudget, setYearOfBudget] = useState([]);

  const options = [];
  for (let i = 10; i < 15; i++) {
    options.push({
      value: i.toString(15) + i,
      label: i.toString(15) + i,
    });
  }

  const onSearch = (values) => {
    setSearch(true);
    setSearchValues({
      companyName: values.companyName ? values.companyName : "",
      yearOfBudgetList: yearOfBudget !== [] ? yearOfBudget : [],
      customerDateFrom: dateFrom ? dateFrom : "",
      customerDateTo: dateTo ? dateTo : "",
      customerTypeList: values.customerTypeList ? values.customerTypeList : [],
      topicList: values.topicList ? values.topicList : [],
      nationalityList: values.nationalityList ? values.nationalityList : [],
      contactName: values.contactName ? values.contactName : "",
      contactPhone: values.contactPhone ? values.contactPhone : "",
      contactPosition: values.contactPosition ? values.contactPosition : "",
      staffName: values.staffName ? values.staffName : "",
      staffDetail: values.staffDetail ? values.staffDetail : "",
    });
  };

  const handleChange = (value) => {
    setYearOfBudget(value);
  };

  const handleCollape = () => {
    setSearchCollapse(!searchCollapse);
  };

  const handleClearSearchForm = () => {
    setSearch(true);
    form.resetFields();
    setSearchValues(initialSearchValues);
    setPageValues(initialPageValues);
  };

  const onChangeRangePicker = (value, e) => {
    if (!value) {
      setDateFrom("");
      setDateTo("");
      return;
    }
    setDateFrom(value[0].format("DD/MM/YYYY"));
    setDateTo(value[1].format("DD/MM/YYYY"));
  };

  return (
    <Content>
      <Form style={{ marginBottom: 20 }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <div className="flex justify-between items-center">
              <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                คลังข้อมูลผู้มีส่วนได้ส่วนเสีย
              </Title>
              <div>
                {roleUser[0]?.isCreate && (
                  <Button
                    type="primary"
                    onClick={() => navigate(routes.add_customer_stakeholder)}
                  >
                    <PlusOutlined /> เพิ่มข้อมูล
                  </Button>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      <Form
        layout={"vertical"}
        form={form}
        style={{
          padding: 20,
          backgroundColor: "#FCFCFC",
          borderRadius: "12px",
          border: "1px solid #F2F2F2",
        }}
        onFinish={onSearch}
      >
        <Row gutter={[24, 16]}>
          <Col className="gutter-row" span={8}>
            <div>
              <Form.Item
                label=""
                name="companyName"
                style={{ fontWeight: 600, marginBottom: 0 }}
              >
                <Input
                  placeholder="ค้นหาชื่อบริษัท"
                  prefix={<SearchOutlined />}
                />
              </Form.Item>
            </div>
          </Col>
          <Col className="gutter-row" span={8}>
            <div style={{}}>
              <Form.Item
                label=""
                name="yearOfBudgetList"
                style={{ fontWeight: 600, marginBottom: 0 }}
              >
                <Select
                  placeholder="ปีงบประมาณ"
                  mode="multiple"
                  onChange={handleChange}
                  style={{
                    width: "100%",
                  }}
                >
                  {(() => {
                    let arr = [];

                    for (let i = 0; i < 5; i++) {
                      arr.push(
                        <Option
                          value={parseInt(years) + 544 - i}
                          selected={years === 2023 ? true : false}
                        >
                          {parseInt(years) + 544 - i}
                        </Option>
                      );
                    }
                    return arr;
                  })()}
                </Select>
              </Form.Item>
            </div>
          </Col>

          <Col className="gutter-row" span={24}>
            <Row>
              <Col span={8}>
                <Form.Item
                  label="กลุ่มลูกค้าตามระยะเวลาการติดต่อ"
                  name="yearOfBudgetList"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <ThaiRangePicker
                      onChange={onChangeRangePicker}
                    />
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {searchCollapse && (
            <>
              <Col span={24}>
                <Divider style={{ margin: "10px 0" }} />
              </Col>

              <Col className="gutter-row" span={8}>
                <Form.Item label="" name="customerTypeList">
                  <Select placeholder="ประเภทผู้ติดต่อ " mode="multiple">
                    <Option value={"หน่วยงานผู้มีส่วนได้ส่วนเสีย"}>
                      หน่วยงานผู้มีส่วนได้ส่วนเสีย
                    </Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={8}>
                <Form.Item label="" name="topicList">
                  <Select placeholder={"ประเด็นติดต่อต่างๆ"} mode="multiple">
                    {contactReason.map((item) => (
                      <Option value={item.dataId}>{item.dataDetailTh}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={8}>
                <Form.Item
                  label=""
                  name="nationalityList"
                  style={{ marginBottom: 0 }}
                >
                  <Select
                    placeholder="สัญชาติผู้มีส่วนได้ส่วนเสีย"
                    mode="multiple"
                  >
                    {countries.map((item) => (
                      <Option value={item.countryId}>
                        {item.countryNameTh}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={8}>
                <Form.Item
                  label=""
                  name="contactName"
                  style={{ marginBottom: 0 }}
                >
                  <Input
                    prefix={<SearchOutlined />}
                    placeholder="ค้นหาชื่อผู้ติดต่อ "
                  />
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={8}>
                <Form.Item
                  label=""
                  name="contactPhone"
                  style={{ marginBottom: 0 }}
                >
                  <Input
                    prefix={<SearchOutlined />}
                    placeholder="ค้นหาเบอร์โทรศัพท์ผู้ติดต่อ "
                  />
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={8}>
                <Form.Item label="" name="contactPosition">
                  <Input
                    prefix={<SearchOutlined />}
                    placeholder="ตำแหน่งผู้ติดต่อ "
                  />
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={12}>
                <Form.Item label="" name="staffName">
                  <Input
                    prefix={<SearchOutlined />}
                    placeholder="ค้นหารายชื่อเจ้าหน้าที่ติดต่อ "
                  />
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={12}>
                <Form.Item label="" name="staffDetail">
                  <Input
                    prefix={<SearchOutlined />}
                    placeholder="ค้นหารายละเอียดการติดต่อ "
                  />
                </Form.Item>
              </Col>
            </>
          )}

          <Col span={24} align="right">
            <Space>
              <Button onClick={handleCollape}>
                {!searchCollapse ? (
                  <CaretDownFilled style={{ fontSize: 17, color: "#2E90FA" }} />
                ) : (
                  <CaretUpFilled style={{ fontSize: 17, color: "#2E90FA" }} />
                )}
              </Button>
              <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default Search;
